// CountrySelect.jsx
import React from "react";
import {
  Box,
  TextField,
  Autocomplete,
  Typography,
  styled,
} from "@mui/material";

// Styled flag image component
const StyledFlagImg = styled("img")({
  width: 24,
  height: 16,
  marginRight: 8,
});

const CountrySelect = ({
  countries,
  value,
  onChange,
  sx,
  InputLabelProps,
  disabled = false,
  ...rest
}) => {
  return (
    <Autocomplete
      id="country-select"
      options={countries}
      value={value}
      onChange={onChange}
      disabled={disabled}
      sx={{ width: "100%", ...sx }}
      autoHighlight
      getOptionLabel={(option) => `${option.label} (${option.phone})`}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{ display: "flex", alignItems: "center" }}
          {...props}
        >
          <StyledFlagImg
            loading="lazy"
            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
            alt=""
          />
          <Typography>
            {option.label} (+{option.phone})
          </Typography>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label="Choose a country"
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password", // disable autocomplete and autofill
          }}
          InputLabelProps={InputLabelProps}
          {...rest}
        />
      )}
    />
  );
};

export default CountrySelect;
